import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type LlmProviderViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  codeValue?: { displayId: string; id: string } | null;
  code: string;
  requiresApiKeyValue?: { displayId: string; id: string } | null;
  requiresApiKey: boolean;
  requiresBaseUrlValue?: { displayId: string; id: string } | null;
  requiresBaseUrl: boolean;
  defaultModelsValue?: { displayId: string; id: string } | null;
  defaultModels: string[];
  logoUrlValue?: { displayId: string; id: string } | null;
  logoUrl: string;
};

export const LlmProviderViewForm: React.FC<LlmProviderViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    name = "",
    code = "",
    requiresApiKey = false,
    requiresBaseUrl = false,
    defaultModels = [],
    logoUrl = "",
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupLlmProviderLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine
                value={name}
                label={langStore.LlmProviderNameLabel}
              />
              <ShowMultiLine
                value={code}
                label={langStore.LlmProviderCodeLabel}
              />
              <ShowBoolean
                value={requiresApiKey}
                label={langStore.LlmProviderRequiresApiKeyLabel}
              />
              <ShowBoolean
                value={requiresBaseUrl}
                label={langStore.LlmProviderRequiresBaseUrlLabel}
              />
              <ShowMultiLine
                value={defaultModels}
                label={langStore.LlmProviderDefaultModelsLabel}
              />
              <ShowMultiLine
                value={logoUrl}
                label={langStore.LlmProviderLogoUrlLabel}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
